// Unpublished Work © 2020-2022 Deere & Company

import {CustomerType} from '../../../enum/customer-type';
import t from 'tcomb';

export const CustomerTypeFacet = t.struct({
    key: CustomerType,
    value: t.String
}, 'CustomerTypeFacet');
